import React, { useContext, useEffect, useRef, useState } from 'react'
import {
    HEADING_TYPE,
    DIVIDER_SIZE,
} from '@helpers/constants'
import Heading from '@components/Heading'
import Divider from '@components/Divider'
import { renderToStaticMarkup } from 'react-dom/server'
import { connectToEditorjs } from '@blocks/connectToEditorjs'
import Icon from '@components/Icon'
import Editor from '@components/Editor'
import Form from '@components/Form'
import EditExerciseWrapper from '@components/EditExerciseWrapper'
import { uploadImage } from '@helpers/api'
import { storagePath } from '@helpers/variables'
import { addOnSaveCallback } from '@state/actions/editorActions'
import { AppContext } from '@state/context'
import { getImageSrc } from '@helpers/utilities'

const EDITOR_ID = 'editorjs-instruction'

/**
 * Quiz questions
 * @returns
 */
const InstructionExerciseComponent = (props) => {
    const {
        initialState,
        handleStateChange,
        onSave,
        id,
    } = props
    const [_, dispatch] = useContext(AppContext)
    const [content, setContent] = useState(initialState.content ?? '{}')
    const [name, setName] = useState(initialState.name ?? '')
    const [preamble, setPreamble] = useState(initialState.preamble ?? {})
    const [image, setImage] = useState(initialState.image ?? null)
    const editorRef = useRef()

    const onChange = async () => {
        const currentContent = await editorRef.current.getContent()
        setContent(JSON.stringify(currentContent))
    }

    /**
     * Broadcast state change up
     */
    useEffect(() => {
      handleStateChange({
        name,
        preamble,
        content,
        image,
      })

      dispatch(
        addOnSaveCallback({
          id,
          callback: async () => {
            if (image?.previewUrl instanceof File) {
              let filename = await uploadImage(image.previewUrl)

              handleStateChange({
                name,
                preamble,
                content,
                image: { filename: `${storagePath}/${filename}` },
              })
            }
          },
        })
      )
    }, [name, preamble, image, content])

    return (
        <div>
            <EditExerciseWrapper
                onSave={onSave}
                type={'Uppgift'}
            >
                <Heading
                    headingLevel={HEADING_TYPE.H3}
                >
                    Namn på övningen
                </Heading>
                <Form.Editor
                    content={name}
                    handleChange={(value) => setName(value)}
                    elementId={`instruction-name-${id}`}
                />
                <Divider size={DIVIDER_SIZE.SMALL} />
                <Heading
                    headingLevel={HEADING_TYPE.H3}
                >
                    Inledande text
                </Heading>
                <Form.Editor
                    content={preamble}
                    handleChange={(value) => setPreamble(value)}
                    // placeholder={'Skriv en inledande text om övningen'}
                    elementId={`instruction-preamble-${id}`}
                />
                <Divider size={DIVIDER_SIZE.SMALL} />

                <Heading
                    headingLevel={HEADING_TYPE.H3}
                >
                    Bild
                </Heading>
                <Form.ImageInput
                    handleImageChange={(e) => {
                        e.preventDefault()

                        setImage({ previewUrl: e.target.files[0] })
                    }}
                    id={'quiz-image'}
                    imagePreviewUrl={getImageSrc(image)}
                    inputKey={'inputKey'}
                    name={'image'}
                    onDelete={() => {
                        setImage(null)
                    }}
                />

                <Divider size={DIVIDER_SIZE.MEDIUM} />
                <Editor
                    ref={editorRef}
                    content={content}
                    onChange={onChange}
                    elementId={EDITOR_ID}
                    exercises={false}
                />
                <Divider size={DIVIDER_SIZE.SMALL} />
            </EditExerciseWrapper>
        </div>
    )
}

export const InstructionExercise = connectToEditorjs(
    InstructionExerciseComponent,
    'Uppgift',
    renderToStaticMarkup(<Icon icon={'InformationCircle'} />)
)
